import type { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { InfoBarBlock as InfoBarBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

export const InfoBarBlock = (
    props: Immutable<{ value: InfoBarBlockValue }>,
): React.JSX.Element => {
    const v = props.value;
    // Legacy rendered `{% for column in value.info %}{% include_block column %}`
    // where each `column` is a ListBlock(RichTextBlock) child. Each item
    // serializes already wrapped in `<div class="rich-text">`, so the items are
    // concatenated and injected as-is: the `.rich-text` divs are the direct
    // flex children of `> div`, which the module styles via
    // `:global(.rich-text)`. No extra wrapper is added here.
    return (
        <section
            className={concatClassNames([
                styles.infoBarBlock,
                v.theme?.theme ?? "",
                v.text_style ?? "",
                v.background_style?.style ?? "",
                getGlobalSpacingClasses(v.spacing),
            ])}
        >
            <div
                dangerouslySetInnerHTML={{
                    __html: (v.info ?? []).join(""),
                }}
            />
        </section>
    );
};
